import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import { useForm, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import { useQueryClient } from "react-query";
import Layout from "./Layout.js";
import { Grid } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import {project_url, admin_url} from "../store/data/Constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  GET_WEEK_QUERY,
  EDIT_WEEK_MUTATION,
  GET_CURRENT_SLEAGUES_QUERY,
  GET_ALL_WEEKS_QUERY
} from "../graphQL/week_qry";
import { REFRESH_TOKEN_MUTATION } from "../graphQL/user_qry";
import adminStyle from "./Admin.module.scss";

// import "../styles.css";

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

/*##########################################################################
## Function : Game Stat
## Description : Submit form data and Add Game Stat for a Player in a Fixture
## Author : SP
## Date: : 2022/03/02
##########################################################################*/
export default function WeekEdit() {
  const {
    control,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const { weekId } = useParams();
  const [successMessage, setSuccessMessage] = useState("");
  const [failedMessage, setFailedMessage] = useState("");
  const navigate = useNavigate();
  const [currentBucketSleagues, setCurrentBucketSleagues] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState([]);
  const [selectedSleague, setSelectedSleague] = useState([]);
  const [allWeeks, setAllWeeks] = useState([]);
  const [weekName, setWeekName] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const {loading:weekLoading, error:weekError, data:weekData } = useQuery(GET_WEEK_QUERY,{
    variables: {
      weekId: parseInt(weekId)
    }
  });
  useEffect(
    () => {
      if (!weekLoading && weekData && weekData.weekObject) {
        setSelectedWeek(weekData.weekObject);
        updateSelectedSleague(weekData.weekObject.sleagueId.sleagueId) 
        setWeekName(weekData.weekObject.name);
        if(weekData.weekObject.startDate)
            setStartDate(new Date(weekData.weekObject.startDate));
        if(weekData.weekObject.endDate)
            setEndDate(new Date(weekData.weekObject.endDate));
      }
      if (weekError){
        console.log(weekError);
        if(weekError.graphQLErrors[0].message === "Signature has expired") {
          navigate(`/lms/${admin_url}/signin`);
        }        
      }
    },[weekData]
  );
  const { loading, error, data } = useQuery(GET_CURRENT_SLEAGUES_QUERY);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION,{onError: (err) => {console.log(err);}});
  const client = useContext(ClientContext);
  
  useEffect(() => {
    if(localStorage.getItem("refreshToken")){
		onRefreshToken();
	}
	else
		navigate(`/lms/${admin_url}/signin`);
  }, [])
  
  const onRefreshToken = async () => {
    const { data:refreshData, error:refreshError } = await refreshToken({variables: { refreshToken: localStorage.getItem("refreshToken")}});
	if (refreshError) {
		if(refreshError.graphQLErrors[0].message === "You do not have permission to perform this action")
			navigate(`/lms/${admin_url}/signin`);
		if(refreshError.graphQLErrors[0].message === "Signature has expired")
			navigate(`/lms/${admin_url}/signin`);
	}
	if(refreshData && refreshData.refreshToken) {
		localStorage.setItem("token", refreshData.refreshToken.token);
        localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
        client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
	}
  };

  useEffect(
    () => {
      console.log(loading);

      if (!loading && data && data.currentBucketSleague) {
        setCurrentBucketSleagues(data.currentBucketSleague);
      }
      if (error && error.graphQLErrors[0].message === "Signature has expired") {
        navigate(`/lms/${admin_url}/signin`);
      }
    },
    [data]
  );

  const {
    loading: loadingAllWeeks,
    error: errorAllWeeks,
    data: dataAllWeeks
  } = useQuery(GET_ALL_WEEKS_QUERY, {
    fetchPolicy: "network-only"
  });

  useEffect(
    () => {
      if (!loadingAllWeeks && dataAllWeeks && dataAllWeeks.allWeeks) {
        setAllWeeks(dataAllWeeks.allWeeks);
        console.log("AllWeeksData----", dataAllWeeks);
      }
    },
    [dataAllWeeks]
  );

  /*
   * Function : setTimeout
   * Description : Disappear message after timeout
   */
  setTimeout(() => {
    setSuccessMessage("");
    setFailedMessage("");
  }, 15000);
  
  const [editWeek] = useManualQuery(EDIT_WEEK_MUTATION, {
    fetchPolicy: "network-only"
  })

  /*
   * Function : onSubmit
   * Description : Submit form data
   */
  const onSubmit = async formData => {
    if (selectedSleague === "0") alert("Please select one sleague.");
    else {
      let findName = allWeeks.find(
        item =>
          item.name.toLowerCase() === weekName.toLowerCase() &&
          parseInt(item.sleagueId.sleagueId) === parseInt(selectedSleague) &&
          parseInt(item.weekId) !== parseInt(weekId)
      );

      if (findName)
        alert(
          "This week name has been already exist in this season. Please enter another one."
        );
      else {
        let start_date = startDate.toISOString();
        let end_date = endDate.toISOString();
        const { data, error } = await editWeek({
          variables: {
            weekId: parseInt(weekId),
            sleagueId: parseInt(selectedSleague),
            name: weekName,
            startDate: start_date,
            endDate: end_date
          }
        });

        if (error) {
          console.log("error", error);
          setFailedMessage("Unfortunately an error occurred.");
          //  setTimeout("");
        } else if (data && data.editWeek) {
          setSuccessMessage("Selected week has been updated successfully.");
          setTimeout(() => {
            navigate(`/lms/${admin_url}/sleague-week`);
          }, 2000);
        }
      }
    }
  };
  
  const updateSelectedSleague = async sleagueId => {
    if (sleagueId !== 0){
      setSelectedSleague(sleagueId)
    }
  };
  const sleagueChange = event => {
    updateSelectedSleague(event.target.value);
  };

  /////////////////////////////////////////////////////////////////////
  return (
    <>
      <Helmet>
        <title>Predictal | Edit Week | Admin</title>
      </Helmet>
      <Grid container direction="row" alignItems="flex-start">
        <Layout />
        <form className={adminStyle.form} onSubmit={handleSubmit(onSubmit)}>
          <h2 className={adminStyle.h2}>Edit week for current season</h2>

          <label className={adminStyle.label} htmlFor="sleagueId">
            <b>Sleague</b>
          </label>
          <select
            className={adminStyle.select}
            id="sleagueId"
            {...register("sleagueId")}
            onChange={sleagueChange} 
          >
            <option value="0">Select a season...</option>
            {currentBucketSleagues.map((currentBucketSleague, i) => (
              <option key={i} value={currentBucketSleague.sleagueId.sleagueId}
                      selected={selectedWeek.sleagueId && selectedWeek.sleagueId != undefined && 
                             selectedWeek.sleagueId.sleagueId===currentBucketSleague.sleagueId.sleagueId?"selected":""}    
              >
                {currentBucketSleague.sleagueId.leagueId.title +
                  " ( " +
                  currentBucketSleague.sleagueId.seasonName +
                  " ) "}
              </option>
            ))}
          </select>

          <label className={adminStyle.label} htmlFor="name">
            Week Name
          </label>
          <input
            className={adminStyle.input}
            id="name"
            {...register("name")}
            defaultValue={weekName}
            onChange={e=>setWeekName(e.target.value)}
          />
          {errors.name && errors.name.type === "required" && (
            <span>Required</span>
          )}
          
            <label className={adminStyle.label} htmlFor="startDate">
              Start Date
            </label>
            <Controller
              control={control}
              name="startDate"
              id="startDate"
              render={({ field }) => (
                <DatePicker
                  className={adminStyle.input}
                  placeholderText="Select date"
                  selected={startDate}
                  onChange={(date)=>setStartDate(date)}
                  dateFormat="yyyy-MM-dd"
                />
              )}
            />
            {errors.startDate && errors.startDate.type === "required" && (
              <span>Required</span>
            )}
            
            <label className={adminStyle.label} htmlFor="endDate">
              End Date
            </label>
            <Controller
              control={control}
              name="endDate"
              id="endDate"
              render={({ field }) => (
                <DatePicker
                  className={adminStyle.input}
                  placeholderText="Select date"
                  selected={endDate}
                  onChange={(date)=>setEndDate(date)}
                  dateFormat="yyyy-MM-dd"
                />
              )}
            />
            {errors.endDate && errors.endDate.type === "required" && (
              <span>Required</span>
            )}

          <input className={adminStyle.input} type="submit" />
          {successMessage && (
            <div className={adminStyle.success}>{successMessage}</div>
          )}
          {failedMessage && (
            <div className={adminStyle.error}>{failedMessage}</div>
          )}
        </form>
      </Grid>
    </>
  );
}
